import React from 'react'
import { DateSpan, RenewalDue, WidgetContainer, Title } from './styles'
import { widgetDateFormat } from './helpers'
import APILoadingSpinnerRenderer from '../../../app/components/apiLoadingSpinner'

const RenewalDateWidget = ({
  renewDate,
  isLoading
}) => {
  return (
    <WidgetContainer>
      <Title>Renewal date</Title>
      {isLoading ? (
        <APILoadingSpinnerRenderer />
      ) : (
        <React.Fragment>
          <DateSpan>
            {widgetDateFormat.renewal(renewDate)}
          </DateSpan>
          <RenewalDue>
            {widgetDateFormat.due(renewDate)}
          </RenewalDue>
        </React.Fragment>
      )}
    </WidgetContainer>
  )
}

export default RenewalDateWidget
